import React from "react";
import { motion } from "framer-motion";
import { GalleryMedia, MediaCaption } from './GalleryMedia';
import { mediaKey } from '../utils/galleryMedia';

export default function GallerySection({ images, selected }) {
  return (
    <main className="max-w-5xl mx-auto px-4 sm:px-6 py-8 sm:py-10 space-y-8 sm:space-y-16">
      {images.map((img, idx) => (
        <motion.div
          key={mediaKey(img)}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: Math.min(idx * 0.08, 0.24) }}
        >
          <GalleryMedia media={img} alt={`${selected} ${idx}`} className="rounded-lg shadow-lg w-full" />
          <MediaCaption media={img} />
        </motion.div>
      ))}
    </main>
  );
}
